import { render, staticRenderFns } from "./ItemAddToCart.vue?vue&type=template&id=36a78caf&scoped=true"
import script from "./ItemAddToCart.vue?vue&type=script&lang=ts"
export * from "./ItemAddToCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a78caf",
  null
  
)

export default component.exports